import useCrud from './useCrud';

const listQuery = `
  query {
    entities: allGroups {
      totalCount
      nodes {
        id
        name
        email
        phone
        website
        config
        adminConfig
        logo
        memo
      }
    }
  }
`;

const retrieveQuery = `
  query($id: Int!) {
    entity: groupById(id: $id) {
      id
      name
      email
      phone
      website
      config
      adminConfig
      logo
      memo
    }
  }
`;

const updateQuery = `
  mutation ($id: Int!, $patch: GroupPatch!) {
    updateEntity: updateGroupById(
      input: {
        id: $id
        groupPatch: $patch
      }
    ) {
      entity: group {
        id
        name
        email
        phone
        website
        config
        adminConfig
        logo
        memo
      }
    }
  }
`;

function getFormSchema() {
  return {
    type: 'object',
    required: ['name'],
    properties: {
      name: {
        title: 'Name',
        type: 'string',
      },
      logo: {
        title: 'Logo',
        type: 'string',
      },
      email: {
        title: 'E-mail',
        type: 'string',
      },
      phone: {
        title: 'Phone',
        type: 'string',
      },
      website: {
        title: 'Website',
        type: 'string',
      },
      memo: {
        title: 'Memo',
        type: 'string',
      },
      config: {
        title: 'Config',
        type: 'object',
        properties: {
          checkDuplicates: {
            type: 'boolean',
            title: 'Check Duplicates',
          },
          uniqueCodeDescription: {
            type: 'string',
            title: 'Unique Code Description',
          },
        },
      },
    },
  };
}

const formUiSchema = {
  config: {
  },
};

const baseUrl = '/groups';

function getConditionsFromKeywords(keywords) {
  console.log(keywords);
  return {};
}

function getListItemConfig(item, history) {
  return {
    title: item.name,
    info: item.contact,
    onClick() {
      history.push(`${baseUrl}/${item.id}`);
    },
  };
}

export default function useGroups({ client }) {
  const { currentEntity, ...rest } = useCrud({
    listQuery,
    retrieveQuery,
    updateQuery,
    client,
    baseUrl,
    getListItemConfig,
    getConditionsFromKeywords,
    formSchema: getFormSchema(),
    formUiSchema,
  });
  return {
    currentEntity,
    ...rest,
  };
}
